<template>
    <div class="mt-5">
        <div class="flex items-end">
            <template v-if="ssn">
                <label for="year_of_birth" class="flex-1 text-sm font-medium">Please confirm the month and day of your birth date</label>
                <h6 @click="$emit('use-primary')" :class="`flex-initial text-xs font-medium text-right cursor-pointer text-${$root.theme}-600`">
                    Or use SSN
                </h6>
            </template>
            <template v-else>
                <label for="year_of_birth" class="font-medium">Please confirm the month and day of your birth date:</label>
            </template>
        </div>
        <div class="mt-2">
            <div class="flex space-x-4 items-center">
                <div class="flex-1">
                    <select id="birth_month" @input="$emit('update:month', $event.target.value)" :class="`flex-1 min-w-0 block w-full bg-white px-4 py-3 rounded-md focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 sm:text-sm border-gray-300 placeholder-gray-300`">
                        <option :value="null">Month</option>
                        <option v-for="i in 12" :key="i" :value="String(i).padStart(2, '0')" v-text="`${String(i).padStart(2, '0')} - ${getMonthName(i)}`"/>
                    </select>
                </div>
                <div>/</div>
                <div class="flex-1">
                    <select id="birth_day" @input="$emit('update:day', $event.target.value)" :class="`flex-1 min-w-0 block w-full bg-white px-4 py-3 rounded-md focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 sm:text-sm border-gray-300 placeholder-gray-300`">
                        <option :value="null">Day</option>
                        <option v-for="i in 31" :key="i" :value="String(i).padStart(2, '0')" v-text="getDay(i)" />
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        props: ['ssn', 'month', 'day'],

        methods: {
            getMonthName(monthNumber) {
                return moment(monthNumber, 'M').format('MMMM');
            },

            getDay(dayNumber) {
                return moment(`01-${dayNumber}`, 'M-D').format('Do');
            }
        }
    }
</script>
